export const tokens = {
    blur100: 'var(--goto-blur-100)',
    blur200: 'var(--goto-blur-200)',
    blur300: 'var(--goto-blur-300)',
    blur400: 'var(--goto-blur-400)',
    blurLarge: 'var(--goto-blur-large)',
    blurMedium: 'var(--goto-blur-medium)',
    blurSmall: 'var(--goto-blur-small)',
    blurXlarge: 'var(--goto-blur-xlarge)',
    elevation100: 'var(--goto-elevation-100)',
    elevation200: 'var(--goto-elevation-200)',
    elevation300: 'var(--goto-elevation-300)',
    elevation400: 'var(--goto-elevation-400)',
    elevationLarge: 'var(--goto-elevation-large)',
    elevationMedium: 'var(--goto-elevation-medium)',
    elevationNone: 'var(--goto-elevation-none)',
    elevationSmall: 'var(--goto-elevation-small)',
    elevationXlarge: 'var(--goto-elevation-xlarge)',
    fontFamily: 'var(--goto-font-family)',
    fontFamilyMono: 'var(--goto-font-family-mono)',
    menuWidth: 'var(--goto-menu-width)',
    topbarBackground: 'var(--goto-topbar-background)',
    topbarBorder: 'var(--goto-topbar-border)',
    navigationRailBackground: 'var(--goto-navigation-rail-background)',
    navigationRailBorderRight: 'var(--goto-navigation-rail-border-right)',
    navigationRailItemHover: 'var(--goto-navigation-rail-item-hover)',
    navigationRailItemActive: 'var(--goto-navigation-rail-item-active)',
    navigationRailItemSelected: 'var(--goto-navigation-rail-item-selected)',
    navigationRailItemDisabled: 'var(--goto-navigation-rail-item-disabled)',
    navigationRailIcon: 'var(--goto-navigation-rail-icon)',
    navigationRailIconSelected: 'var(--goto-navigation-rail-icon-selected)',
    navigationRailIconDisabled: 'var(--goto-navigation-rail-icon-disabled)',
    navigationRailText: 'var(--goto-navigation-rail-text)',
    navigationRailTextSelected: 'var(--goto-navigation-rail-text-selected)',
    navigationRailTextDisabled: 'var(--goto-navigation-rail-text-disabled)',
    navigationRailFocus: 'var(--goto-navigation-rail-focus)',
    navigationRailHighlight: 'var(--goto-navigation-rail-highlight)',
    avatar24: 'var(--goto-avatar-24)',
    avatar30: 'var(--goto-avatar-30)',
    avatar36: 'var(--goto-avatar-36)',
    avatar48: 'var(--goto-avatar-48)',
    avatar64: 'var(--goto-avatar-64)',
    avatar80: 'var(--goto-avatar-80)',
    avatar180: 'var(--goto-avatar-180)',
    codeTextSmall: 'var(--goto-code-text-small)',
    codeTextMedium: 'var(--goto-code-text-medium)',
    bodySmall: 'var(--goto-body-small)',
    bodyMedium: 'var(--goto-body-medium)',
    bodyLarge: 'var(--goto-body-large)',
    bodySmallSemibold: 'var(--goto-body-small-semibold)',
    bodyMediumSemibold: 'var(--goto-body-medium-semibold)',
    buttonTextSmall: 'var(--goto-button-text-small)',
    buttonTextMedium: 'var(--goto-button-text-medium)',
    buttonTextLarge: 'var(--goto-button-text-large)',
    buttonTextXlarge: 'var(--goto-button-text-xlarge)',
    captionDefault01: 'var(--goto-caption-default-01)',
    captionDefault02: 'var(--goto-caption-default-02)',
    captionSmall01: 'var(--goto-caption-small-01)',
    captionSmall02: 'var(--goto-caption-small-02)',
    headingSmall: 'var(--goto-heading-small)',
    headingMedium: 'var(--goto-heading-medium)',
    headingLarge: 'var(--goto-heading-large)',
    headingXlarge: 'var(--goto-heading-xlarge)',
    avatarLarge: 'var(--goto-avatar-large)',
    avatarMedium: 'var(--goto-avatar-medium)',
    avatarSmall: 'var(--goto-avatar-small)',
    avatarXlarge: 'var(--goto-avatar-xlarge)',
    avatarXsmall: 'var(--goto-avatar-xsmall)',
    avatarXxlarge: 'var(--goto-avatar-xxlarge)',
    avatarXxxlarge: 'var(--goto-avatar-xxxlarge)',
    bodyLargeStrong: 'var(--goto-body-large-strong)',
    bodyMediumStrong: 'var(--goto-body-medium-strong)',
    bodySmallStrong: 'var(--goto-body-small-strong)',
    buttonLarge: 'var(--goto-button-large)',
    buttonMedium: 'var(--goto-button-medium)',
    buttonSmall: 'var(--goto-button-small)',
    buttonXlarge: 'var(--goto-button-xlarge)',
    captionMedium: 'var(--goto-caption-medium)',
    captionMediumStrong: 'var(--goto-caption-medium-strong)',
    captionSmall: 'var(--goto-caption-small)',
    captionSmallStrong: 'var(--goto-caption-small-strong)',
    codeMedium: 'var(--goto-code-medium)',
    codeSmall: 'var(--goto-code-small)',
    layout00: 'var(--goto-layout-00)',
    layout01: 'var(--goto-layout-01)',
    layout02: 'var(--goto-layout-02)',
    layout03: 'var(--goto-layout-03)',
    layout04: 'var(--goto-layout-04)',
    layout05: 'var(--goto-layout-05)',
    layout06: 'var(--goto-layout-06)',
    layout07: 'var(--goto-layout-07)',
    goToMeeting: 'var(--goto-go-to-meeting)',
    goToRoom: 'var(--goto-go-to-room)',
    goToConnect: 'var(--goto-go-to-connect)',
    goToWebinar: 'var(--goto-go-to-webinar)',
    goToAssist: 'var(--goto-go-to-assist)',
    goToResolve: 'var(--goto-go-to-resolve)',
    goToTraining: 'var(--goto-go-to-training)',
    openVoice: 'var(--goto-open-voice)',
    jive: 'var(--goto-jive)',
    spacing00: 'var(--goto-spacing-00)',
    spacing01: 'var(--goto-spacing-01)',
    spacing02: 'var(--goto-spacing-02)',
    spacing03: 'var(--goto-spacing-03)',
    spacing04: 'var(--goto-spacing-04)',
    spacing05: 'var(--goto-spacing-05)',
    spacing06: 'var(--goto-spacing-06)',
    spacing07: 'var(--goto-spacing-07)',
    spacing08: 'var(--goto-spacing-08)',
    spacing09: 'var(--goto-spacing-09)',
    spacing10: 'var(--goto-spacing-10)',
    spacing11: 'var(--goto-spacing-11)',
    transitionDialogIn: 'var(--goto-transition-dialog-in)',
    transitionDialogOut: 'var(--goto-transition-dialog-out)',
    radiusCircle: 'var(--goto-radius-circle)',
    radiusLarge: 'var(--goto-radius-large)',
    radiusMedium: 'var(--goto-radius-medium)',
    radiusNone: 'var(--goto-radius-none)',
    radiusSmall: 'var(--goto-radius-small)',
    radiusXlarge: 'var(--goto-radius-xlarge)',
    checkboxCheckedHover: 'var(--goto-checkbox-checked-hover)',
    checkboxCheckedPressed: 'var(--goto-checkbox-checked-pressed)',
    badgeBackgroundDisabled: 'var(--goto-badge-background-disabled)',
    badgeIconDisabled: 'var(--goto-badge-icon-disabled)',
    alertBackground: 'var(--goto-alert-background)',
    alertBorder: 'var(--goto-alert-border)',
    chipBackground: 'var(--goto-chip-background)',
    chipBackgroundSelected: 'var(--goto-chip-background-selected)',
    chipBackgroundSelectedHover: 'var(--goto-chip-background-selected-hover)',
    chipBackgroundSelectedActive: 'var(--goto-chip-background-selected-active)',
    searchFieldBackground: 'var(--goto-search-field-background)',
    searchFieldBackgroundActive: 'var(--goto-search-field-background-active)',
    searchFieldBorderHover: 'var(--goto-search-field-border-hover)',
    searchFieldIconDisabled: 'var(--goto-search-field-icon-disabled)',
    searchFieldTextDisabled: 'var(--goto-search-field-text-disabled)',
    searchFieldBackgroundDisabled: 'var(--goto-search-field-background-disabled)',
    searchFieldOpacityDisabled: 'var(--goto-search-field-opacity-disabled)',
    searchFieldClearIconBackground: 'var(--goto-search-field-clear-icon-background)',
    selectInlineBorder: 'var(--goto-select-inline-border)',
    selectInlineFont: 'var(--goto-select-inline-font)',
    selectInlineBorderHover: 'var(--goto-select-inline-border-hover)',
    selectInlineBackgroundHover: 'var(--goto-select-inline-background-hover)',
    selectInlineBorderActive: 'var(--goto-select-inline-border-active)',
    selectInlineBackgroundActive: 'var(--goto-select-inline-background-active)',
    roundButtonIconColor: 'var(--goto-round-button-icon-color)',
    roundButtonBorderSuccess: 'var(--goto-round-button-border-success)',
    roundButtonBorderDanger: 'var(--goto-round-button-border-danger)',
    tabsIndicatorBackground: 'var(--goto-tabs-indicator-background)',
    skeletonGradient: 'var(--goto-skeleton-gradient)',
    inputSuccessBorder: 'var(--goto-input-success-border)',
    inputDangerBorder: 'var(--goto-input-danger-border)',
    navDrawerItemBackgroundSelected: 'var(--goto-nav-drawer-item-background-selected)',
    navDrawerItemIconColor: 'var(--goto-nav-drawer-item-icon-color)',
    navDrawerItemIconColorSelected: 'var(--goto-nav-drawer-item-icon-color-selected)',
    avatarBackgroundSecondaryDisabled: 'var(--goto-avatar-background-secondary-disabled)',
    avatarColorSecondaryDisabled: 'var(--goto-avatar-color-secondary-disabled)',
    avatarBorderSecondaryDisabled: 'var(--goto-avatar-border-secondary-disabled)',
    popoverBorderColor: 'var(--goto-popover-border-color)',
    popoverElevation: 'var(--goto-popover-elevation)',
    emptyStateIconColor: 'var(--goto-empty-state-icon-color)',
    radioButtonBorderDisabled: 'var(--goto-radio-button-border-disabled)',
    menuBackground: 'var(--goto-menu-background)',
    menuBackgroundHover: 'var(--goto-menu-background-hover)',
    menuColorDisabled: 'var(--goto-menu-color-disabled)',
    menuColorHover: 'var(--goto-menu-color-hover)',
    menuIconColor: 'var(--goto-menu-icon-color)',
    menuElevation: 'var(--goto-menu-elevation)',
    menuPresenceAvailableColor: 'var(--goto-menu-presence-available-color)',
    menuPresenceBusyColor: 'var(--goto-menu-presence-busy-color)',
    menuPresenceAwayColor: 'var(--goto-menu-presence-away-color)',
    menuPresenceDndColor: 'var(--goto-menu-presence-dnd-color)',
    menuPresenceOfflineColor: 'var(--goto-menu-presence-offline-color)',
    buttonNeutralInverseBorder: 'var(--goto-button-neutral-inverse-border)',
    buttonNeutralInverseBackgroundHover: 'var(--goto-button-neutral-inverse-background-hover)',
    buttonNeutralInverseBackgroundActive: 'var(--goto-button-neutral-inverse-background-active)',
    snackbarContentColor: 'var(--goto-snackbar-content-color)',
    snackbarBackground: 'var(--goto-snackbar-background)',
    progressBackgroundInverse: 'var(--goto-progress-background-inverse)',
    switchBackgroundDisabled: 'var(--goto-switch-background-disabled)',
    switchCheckedBackgroundDisabled: 'var(--goto-switch-checked-background-disabled)',
    switchKnobDisabled: 'var(--goto-switch-knob-disabled)',
    tileBackground: 'var(--goto-tile-background)',
    tileBorder: 'var(--goto-tile-border)',
    tileBorderSecondary: 'var(--goto-tile-border-secondary)',
    tileBackgroundSelected: 'var(--goto-tile-background-selected)',
    tileBackgroundHover: 'var(--goto-tile-background-hover)',
    tileBackgroundActive: 'var(--goto-tile-background-active)',
    tileBackgroundSecondary: 'var(--goto-tile-background-secondary)',
    tileBackgroundSecondaryHover: 'var(--goto-tile-background-secondary-hover)',
    tileBackgroundSecondaryActive: 'var(--goto-tile-background-secondary-active)',
    tileBackgroundDisabled: 'var(--goto-tile-background-disabled)',
    tileBorderDisabled: 'var(--goto-tile-border-disabled)',
    optionBackgroundSelected: 'var(--goto-option-background-selected)',
    optionColorSelected: 'var(--goto-option-color-selected)',
    optionIconColorSelected: 'var(--goto-option-icon-color-selected)',
    optionBackgroundHover: 'var(--goto-option-background-hover)',
    optionColorDisabled: 'var(--goto-option-color-disabled)',
    optionIconColorDisabled: 'var(--goto-option-icon-color-disabled)',
    tooltipFont: 'var(--goto-tooltip-font)',
    avatarNeutral: 'var(--goto-avatar-neutral)',
    avatarSecondary: 'var(--goto-avatar-secondary)',
    avatarSecondaryIconColor: 'var(--goto-avatar-secondary-icon-color)',
    avatarGroupMaxHint: 'var(--goto-avatar-group-max-hint)',
    avatarPrimary01: 'var(--goto-avatar-primary-01)',
    avatarPrimary02: 'var(--goto-avatar-primary-02)',
    avatarPrimary03: 'var(--goto-avatar-primary-03)',
    avatarPrimary04: 'var(--goto-avatar-primary-04)',
    avatarPrimary05: 'var(--goto-avatar-primary-05)',
    avatarPrimary06: 'var(--goto-avatar-primary-06)',
    avatarPrimary07: 'var(--goto-avatar-primary-07)',
    avatarPrimary08: 'var(--goto-avatar-primary-08)',
    avatarPrimary09: 'var(--goto-avatar-primary-09)',
    avatarPrimary10: 'var(--goto-avatar-primary-10)',
    avatarPrimary11: 'var(--goto-avatar-primary-11)',
    avatarPrimary12: 'var(--goto-avatar-primary-12)',
    avatarPrimary13: 'var(--goto-avatar-primary-13)',
    avatarPrimary14: 'var(--goto-avatar-primary-14)',
    avatarPrimary15: 'var(--goto-avatar-primary-15)',
    avatarPrimary16: 'var(--goto-avatar-primary-16)',
    avatarPrimary17: 'var(--goto-avatar-primary-17)',
    avatarPrimary18: 'var(--goto-avatar-primary-18)',
    border: 'var(--goto-border)',
    avatarDisabledColor: 'var(--goto-avatar-disabled-color)',
    danger01: 'var(--goto-danger-01)',
    danger02: 'var(--goto-danger-02)',
    danger03: 'var(--goto-danger-03)',
    disabled01: 'var(--goto-disabled-01)',
    disabled02: 'var(--goto-disabled-02)',
    disabled03: 'var(--goto-disabled-03)',
    disabled04: 'var(--goto-disabled-04)',
    disabled05: 'var(--goto-disabled-05)',
    experienceBadgeAssist: 'var(--goto-experience-badge-assist)',
    experienceBadgeCustomer: 'var(--goto-experience-badge-customer)',
    experienceBadgeMeeting: 'var(--goto-experience-badge-meeting)',
    experienceBadgeMessage: 'var(--goto-experience-badge-message)',
    experienceBadgeVoice: 'var(--goto-experience-badge-voice)',
    experienceBadgeTraining: 'var(--goto-experience-badge-training)',
    experienceBadgeWebinar: 'var(--goto-experience-badge-webinar)',
    experienceBadgeGotoresolve: 'var(--goto-experience-badge-gotoresolve)',
    field01: 'var(--goto-field-01)',
    field02: 'var(--goto-field-02)',
    field03: 'var(--goto-field-03)',
    field04: 'var(--goto-field-04)',
    focusError: 'var(--goto-focus-error)',
    focusSuccess: 'var(--goto-focus-success)',
    highlightError: 'var(--goto-highlight-error)',
    highlightSuccess: 'var(--goto-highlight-success)',
    highlightErrorSmall: 'var(--goto-highlight-error-small)',
    highlightSuccessSmall: 'var(--goto-highlight-success-small)',
    hover01: 'var(--goto-hover-01)',
    hover02: 'var(--goto-hover-02)',
    hoverDanger: 'var(--goto-hover-danger)',
    hoverPrimary: 'var(--goto-hover-primary)',
    hoverSecondary: 'var(--goto-hover-secondary)',
    hoverSuccess: 'var(--goto-hover-success)',
    hoverTertiary: 'var(--goto-hover-tertiary)',
    icon01: 'var(--goto-icon-01)',
    icon02: 'var(--goto-icon-02)',
    icon03: 'var(--goto-icon-03)',
    icon04: 'var(--goto-icon-04)',
    icon05: 'var(--goto-icon-05)',
    information01: 'var(--goto-information-01)',
    information02: 'var(--goto-information-02)',
    information03: 'var(--goto-information-03)',
    interactive01: 'var(--goto-interactive-01)',
    interactive02: 'var(--goto-interactive-02)',
    interactive03: 'var(--goto-interactive-03)',
    inverse01: 'var(--goto-inverse-01)',
    inverse02: 'var(--goto-inverse-02)',
    inverseBorder: 'var(--goto-inverse-border)',
    inverseDisabled: 'var(--goto-inverse-disabled)',
    inverseHover01: 'var(--goto-inverse-hover-01)',
    inverseFocus: 'var(--goto-inverse-focus)',
    inverseInteractive01: 'var(--goto-inverse-interactive-01)',
    inverseHighlight: 'var(--goto-inverse-highlight)',
    inversePressed01: 'var(--goto-inverse-pressed-01)',
    inverseUi05: 'var(--goto-inverse-ui-05)',
    orange01: 'var(--goto-orange-01)',
    orange03: 'var(--goto-orange-03)',
    overlay01: 'var(--goto-overlay-01)',
    presenceAvailable: 'var(--goto-presence-available)',
    presenceAway: 'var(--goto-presence-away)',
    presenceBusy: 'var(--goto-presence-busy)',
    presenceDnd: 'var(--goto-presence-dnd)',
    presenceOffline: 'var(--goto-presence-offline)',
    pressed01: 'var(--goto-pressed-01)',
    pressed02: 'var(--goto-pressed-02)',
    pressedDanger: 'var(--goto-pressed-danger)',
    pressedPrimary: 'var(--goto-pressed-primary)',
    pressedSecondary: 'var(--goto-pressed-secondary)',
    pressedSuccess: 'var(--goto-pressed-success)',
    pressedTertiary: 'var(--goto-pressed-tertiary)',
    purple01: 'var(--goto-purple-01)',
    purple03: 'var(--goto-purple-03)',
    success01: 'var(--goto-success-01)',
    success02: 'var(--goto-success-02)',
    success03: 'var(--goto-success-03)',
    text01: 'var(--goto-text-01)',
    text02: 'var(--goto-text-02)',
    text03: 'var(--goto-text-03)',
    text04: 'var(--goto-text-04)',
    text05: 'var(--goto-text-05)',
    text06: 'var(--goto-text-06)',
    text07: 'var(--goto-text-07)',
    textError01: 'var(--goto-text-error-01)',
    textError02: 'var(--goto-text-error-02)',
    textInfo: 'var(--goto-text-info)',
    textNeutral: 'var(--goto-text-neutral)',
    textSuccess01: 'var(--goto-text-success-01)',
    textSuccess02: 'var(--goto-text-success-02)',
    textWarning01: 'var(--goto-text-warning-01)',
    textWarning02: 'var(--goto-text-warning-02)',
    warning01: 'var(--goto-warning-01)',
    warning02: 'var(--goto-warning-02)',
    warning03: 'var(--goto-warning-03)',
    ui01: 'var(--goto-ui-01)',
    ui02: 'var(--goto-ui-02)',
    ui03: 'var(--goto-ui-03)',
    ui04: 'var(--goto-ui-04)',
    ui05: 'var(--goto-ui-05)',
    ui06: 'var(--goto-ui-06)',
    uiBackground: 'var(--goto-ui-background)',
    uiBase01: 'var(--goto-ui-base-01)',
    uiBase02: 'var(--goto-ui-base-02)',
    focus: 'var(--goto-focus)',
    highlight: 'var(--goto-highlight)',
    highlightBase: 'var(--goto-highlight-base)',
    highlightSmall: 'var(--goto-highlight-small)',
    link: 'var(--goto-link)',
    neutral: 'var(--goto-neutral)',
    neutral03: 'var(--goto-neutral-03)',
    contextualMenuBackgroundColor: 'var(--goto-contextual-menu-background-color)',
    toolbarBackgroundColor: 'var(--goto-toolbar-background-color)',
    toolbarHoverBackgroundColor: 'var(--goto-toolbar-hover-background-color)',
    toolbarPressedBackgroundColor: 'var(--goto-toolbar-pressed-background-color)',
    toolbarDisabledBackgroundColor: 'var(--goto-toolbar-disabled-background-color)',
    toolbarDisabledIconColor: 'var(--goto-toolbar-disabled-icon-color)',
    avatarColor00: 'var(--goto-avatar-color-00)',
    avatarColor01: 'var(--goto-avatar-color-01)',
    avatarColor02: 'var(--goto-avatar-color-02)',
    avatarColor10: 'var(--goto-avatar-color-10)',
    avatarColor11: 'var(--goto-avatar-color-11)',
    avatarColor12: 'var(--goto-avatar-color-12)',
    avatarColor20: 'var(--goto-avatar-color-20)',
    avatarColor21: 'var(--goto-avatar-color-21)',
    avatarColor22: 'var(--goto-avatar-color-22)',
    avatarColor30: 'var(--goto-avatar-color-30)',
    avatarColor31: 'var(--goto-avatar-color-31)',
    avatarColor32: 'var(--goto-avatar-color-32)',
    avatarColor40: 'var(--goto-avatar-color-40)',
    avatarColor41: 'var(--goto-avatar-color-41)',
    avatarColor42: 'var(--goto-avatar-color-42)',
    avatarColor50: 'var(--goto-avatar-color-50)',
    avatarColor51: 'var(--goto-avatar-color-51)',
    avatarColor52: 'var(--goto-avatar-color-52)',
    avatarColorPrimary: 'var(--goto-avatar-color-primary)',
    avatarColorSecondary: 'var(--goto-avatar-color-secondary)',
    backgroundColorDefault: 'var(--goto-background-color-default)',
    backgroundColorSecondary: 'var(--goto-background-color-secondary)',
    badgeColorAssist: 'var(--goto-badge-color-assist)',
    badgeColorAudio: 'var(--goto-badge-color-audio)',
    badgeColorCustom: 'var(--goto-badge-color-custom)',
    badgeColorCustomer: 'var(--goto-badge-color-customer)',
    badgeColorDisabled: 'var(--goto-badge-color-disabled)',
    badgeColorFiles: 'var(--goto-badge-color-files)',
    badgeColorGotoresolve: 'var(--goto-badge-color-gotoresolve)',
    badgeColorMeeting: 'var(--goto-badge-color-meeting)',
    badgeColorMessage: 'var(--goto-badge-color-message)',
    badgeColorTraining: 'var(--goto-badge-color-training)',
    badgeColorVoice: 'var(--goto-badge-color-voice)',
    badgeColorWebinar: 'var(--goto-badge-color-webinar)',
    blue100: 'var(--goto-blue-100)',
    blue200: 'var(--goto-blue-200)',
    blue300: 'var(--goto-blue-300)',
    blue400: 'var(--goto-blue-400)',
    blue500: 'var(--goto-blue-500)',
    blue600: 'var(--goto-blue-600)',
    blue700: 'var(--goto-blue-700)',
    borderColorBrand: 'var(--goto-border-color-brand)',
    borderColorDanger: 'var(--goto-border-color-danger)',
    borderColorDefault: 'var(--goto-border-color-default)',
    borderColorInverted: 'var(--goto-border-color-inverted)',
    borderColorPersistent: 'var(--goto-border-color-persistent)',
    borderColorSecondary: 'var(--goto-border-color-secondary)',
    borderColorSuccess: 'var(--goto-border-color-success)',
    borderColorWarning: 'var(--goto-border-color-warning)',
    brand100: 'var(--goto-brand-100)',
    brand200: 'var(--goto-brand-200)',
    brand300: 'var(--goto-brand-300)',
    brand400: 'var(--goto-brand-400)',
    brand500: 'var(--goto-brand-500)',
    brand600: 'var(--goto-brand-600)',
    brand700: 'var(--goto-brand-700)',
    focusBorderColorDanger: 'var(--goto-focus-border-color-danger)',
    focusBorderColorDefault: 'var(--goto-focus-border-color-default)',
    focusBorderColorPersistent: 'var(--goto-focus-border-color-persistent)',
    focusBorderColorSuccess: 'var(--goto-focus-border-color-success)',
    focusColorHighlightDanger: 'var(--goto-focus-color-highlight-danger)',
    focusColorHighlightDefault: 'var(--goto-focus-color-highlight-default)',
    focusColorHighlightPersistent: 'var(--goto-focus-color-highlight-persistent)',
    focusColorHighlightSuccess: 'var(--goto-focus-color-highlight-success)',
    gradientColorSkeleton: 'var(--goto-gradient-color-skeleton)',
    green100: 'var(--goto-green-100)',
    green200: 'var(--goto-green-200)',
    green300: 'var(--goto-green-300)',
    green400: 'var(--goto-green-400)',
    green500: 'var(--goto-green-500)',
    green600: 'var(--goto-green-600)',
    green700: 'var(--goto-green-700)',
    iconColorBrandDefault: 'var(--goto-icon-color-brand-default)',
    iconColorBrandPersistent: 'var(--goto-icon-color-brand-persistent)',
    iconColorDanger: 'var(--goto-icon-color-danger)',
    iconColorDefault: 'var(--goto-icon-color-default)',
    iconColorDisabled: 'var(--goto-icon-color-disabled)',
    iconColorInverted: 'var(--goto-icon-color-inverted)',
    iconColorPersistent: 'var(--goto-icon-color-persistent)',
    iconColorPersistentDisabled: 'var(--goto-icon-color-persistent-disabled)',
    iconColorSecondary: 'var(--goto-icon-color-secondary)',
    iconColorSuccess: 'var(--goto-icon-color-success)',
    iconColorWarning: 'var(--goto-icon-color-warning)',
    interactiveColorBrandDefault: 'var(--goto-interactive-color-brand-default)',
    interactiveColorBrandHover: 'var(--goto-interactive-color-brand-hover)',
    interactiveColorBrandPressed: 'var(--goto-interactive-color-brand-pressed)',
    interactiveColorDangerDefault: 'var(--goto-interactive-color-danger-default)',
    interactiveColorDangerHover: 'var(--goto-interactive-color-danger-hover)',
    interactiveColorDangerPressed: 'var(--goto-interactive-color-danger-pressed)',
    interactiveColorDisabled: 'var(--goto-interactive-color-disabled)',
    interactiveColorNeutralDefault: 'var(--goto-interactive-color-neutral-default)',
    interactiveColorNeutralHover: 'var(--goto-interactive-color-neutral-hover)',
    interactiveColorNeutralPressed: 'var(--goto-interactive-color-neutral-pressed)',
    interactiveColorPersistentDefault: 'var(--goto-interactive-color-persistent-default)',
    interactiveColorPersistentHover: 'var(--goto-interactive-color-persistent-hover)',
    interactiveColorPersistentPressed: 'var(--goto-interactive-color-persistent-pressed)',
    interactiveColorPrimaryDefault: 'var(--goto-interactive-color-primary-default)',
    interactiveColorPrimaryHover: 'var(--goto-interactive-color-primary-hover)',
    interactiveColorPrimaryPressed: 'var(--goto-interactive-color-primary-pressed)',
    interactiveColorSecondaryDefault: 'var(--goto-interactive-color-secondary-default)',
    interactiveColorSecondaryHover: 'var(--goto-interactive-color-secondary-hover)',
    interactiveColorSecondaryPressed: 'var(--goto-interactive-color-secondary-pressed)',
    interactiveColorSuccessDefault: 'var(--goto-interactive-color-success-default)',
    interactiveColorSuccessHover: 'var(--goto-interactive-color-success-hover)',
    interactiveColorSuccessPressed: 'var(--goto-interactive-color-success-pressed)',
    neutral000: 'var(--goto-neutral-000)',
    neutral050: 'var(--goto-neutral-050)',
    neutral100: 'var(--goto-neutral-100)',
    neutral200: 'var(--goto-neutral-200)',
    neutral300: 'var(--goto-neutral-300)',
    neutral400: 'var(--goto-neutral-400)',
    neutral500: 'var(--goto-neutral-500)',
    neutral600: 'var(--goto-neutral-600)',
    neutral700: 'var(--goto-neutral-700)',
    neutral800: 'var(--goto-neutral-800)',
    neutral900: 'var(--goto-neutral-900)',
    orange100: 'var(--goto-orange-100)',
    orange200: 'var(--goto-orange-200)',
    orange300: 'var(--goto-orange-300)',
    orange400: 'var(--goto-orange-400)',
    orange500: 'var(--goto-orange-500)',
    orange600: 'var(--goto-orange-600)',
    orange700: 'var(--goto-orange-700)',
    purple100: 'var(--goto-purple-100)',
    purple200: 'var(--goto-purple-200)',
    purple300: 'var(--goto-purple-300)',
    purple400: 'var(--goto-purple-400)',
    purple500: 'var(--goto-purple-500)',
    purple600: 'var(--goto-purple-600)',
    purple700: 'var(--goto-purple-700)',
    red100: 'var(--goto-red-100)',
    red200: 'var(--goto-red-200)',
    red300: 'var(--goto-red-300)',
    red400: 'var(--goto-red-400)',
    red500: 'var(--goto-red-500)',
    red600: 'var(--goto-red-600)',
    red700: 'var(--goto-red-700)',
    scrimColor: 'var(--goto-scrim-color)',
    surfaceColorBrandDefault: 'var(--goto-surface-color-brand-default)',
    surfaceColorBrandSecondary: 'var(--goto-surface-color-brand-secondary)',
    surfaceColorDangerDefault: 'var(--goto-surface-color-danger-default)',
    surfaceColorDangerSecondary: 'var(--goto-surface-color-danger-secondary)',
    surfaceColorDefault: 'var(--goto-surface-color-default)',
    surfaceColorDefaultSemitransparent: 'var(--goto-surface-color-default-semitransparent)',
    surfaceColorInverted: 'var(--goto-surface-color-inverted)',
    surfaceColorPersistent: 'var(--goto-surface-color-persistent)',
    surfaceColorSecondary: 'var(--goto-surface-color-secondary)',
    surfaceColorSuccessDefault: 'var(--goto-surface-color-success-default)',
    surfaceColorSuccessSecondary: 'var(--goto-surface-color-success-secondary)',
    surfaceColorTertiary: 'var(--goto-surface-color-tertiary)',
    surfaceColorUtilityOrange: 'var(--goto-surface-color-utility-orange)',
    surfaceColorUtilityPurple: 'var(--goto-surface-color-utility-purple)',
    surfaceColorWarningDefault: 'var(--goto-surface-color-warning-default)',
    surfaceColorWarningSecondary: 'var(--goto-surface-color-warning-secondary)',
    typeColorBrandDefault: 'var(--goto-type-color-brand-default)',
    typeColorBrandPersistent: 'var(--goto-type-color-brand-persistent)',
    typeColorDanger: 'var(--goto-type-color-danger)',
    typeColorDefault: 'var(--goto-type-color-default)',
    typeColorDisabled: 'var(--goto-type-color-disabled)',
    typeColorInverted: 'var(--goto-type-color-inverted)',
    typeColorPersistent: 'var(--goto-type-color-persistent)',
    typeColorPersistentDisabled: 'var(--goto-type-color-persistent-disabled)',
    typeColorSecondary: 'var(--goto-type-color-secondary)',
    typeColorSecondaryInverted: 'var(--goto-type-color-secondary-inverted)',
    typeColorSuccess: 'var(--goto-type-color-success)',
    typeColorWarning: 'var(--goto-type-color-warning)',
    yellow100: 'var(--goto-yellow-100)',
    yellow200: 'var(--goto-yellow-200)',
    yellow300: 'var(--goto-yellow-300)',
    yellow400: 'var(--goto-yellow-400)',
    yellow500: 'var(--goto-yellow-500)',
    yellow600: 'var(--goto-yellow-600)',
    yellow700: 'var(--goto-yellow-700)',
};
